import { graphql } from "gatsby";
import React from "react";
import "./pullQuote.scss";

interface Props {
  citation: string;
  value: string;
}

export const query = graphql`
  fragment PullQuoteBlock on WpCorePullquoteBlock {
    attributes {
      ... on WpCorePullquoteBlockAttributes {
        citation
        value
      }
    }
  }
`;

const PullQuote: React.FC<Props> = (props) => {
  return (
    <figure className="pull-quote">
      <blockquote className="block" dangerouslySetInnerHTML={{__html: props.value}} />
      <figcaption dangerouslySetInnerHTML={{__html: props.citation}} />
    </figure>
  );
};

export default PullQuote;
